import { Component } from '@angular/core';
import { ReactPageComponent } from '../../../../common';
import { CompaniesPage } from './page';

@Component({
  selector: 'app-page-companies',
  template: '<div class="react-page" #container></div>'
})
export class PageCompaniesComponent extends ReactPageComponent {
  get Component(){
    return CompaniesPage;
  }
}
